<template>
    <div>
        <div class="title">Edit Recurring SMS Campaign {{ campaign.id }}</div>
        <edit-sms-campaign
            :campaign="campaign"
            :submit-loading="submitLoading"
            @updateCampaign="updateSMSCampaign"
            @cancel="returnToInfoList"
        />
        <alert :show-alert="alert.show" :message="alert.message" :type="alert.type" />
    </div>
</template>

<script>
    import recurringSmsCampaignService from '@/services/recurring-sms-campaign-service'
    import editSmsCampaign from '@/components/SMSCampaignEditRecurring.vue'
    import Alert from '@/components/Alert.vue'
    export default {
        components: { Alert, editSmsCampaign },
        data() {
            return {
                campaign: {},
                submitLoading: false,
                alert: {
                    show: false,
                    message: '',
                    type: null
                }
            }
        },
        computed: {
            getCurrentSMSRecurringCampaign() {
                return this.campaign ?? this.$store.getters.getCurrentRecurringSMSCampaign
            }
        },
        created() {
            this.fetchSMSCampaignById(this.$route.params.campaignId)
        },
        methods: {
            fetchSMSCampaignById(id) {
                recurringSmsCampaignService.getSMSCampaignById(id)
                    .then(resp => {
                        this.campaign = resp.data
                    })
                    .catch(err => {
                        if (err.status === 404) {
                            return this.returnToInfoList()
                        }
                        throw err
                    })
            },
            updateSMSCampaign(textTemplate) {
                this.submitLoading = true
                this.campaign.textTemplate = textTemplate
                recurringSmsCampaignService.updateSMSCampaign(this.campaign).then(() => {
                    this.setAlert('Campaign Updated', 'success')
                    setTimeout(() => { this.$router.push(`/recurring-sms/${this.getCurrentSMSRecurringCampaign.id}`) }, 3000)
                }).catch(error => {
                    this.setAlert('Error updating the campaign' + error.response.data.message, 'error')
                }).finally(() => {
                    this.submitLoading = false
                })
            },
            returnToInfoList() {
                this.$router.push('/recurring-sms/')
            },
            setAlert(message, type) {
                this.alert.show = true
                this.alert.message = message
                this.alert.type = type
            }
        }
    }
</script>

<style scoped>

.title {
    font-size: 1.5rem !important;
    margin-bottom: 10px;
}

.edit-btn {
    text-transform: none !important;
    background: #00acd6 !important;
    color: white;
    margin: 15px;
    width: 90%;
}

.form-field {
    width: 100%;
    padding-left: 15px;
    padding-right: 15px;
}

</style>
